





























































































































































































































import { Vue, Component } from "vue-property-decorator";
import RandomWords from "random-words";
import { API_ENDPOINTS, Events, EventResponse } from "../configs";
import { RoomDialog, WonDialog, ErrorDialog } from "../components";
import { copyToClipBoard, goHome } from "../services";

@Component({
  components: {
    RoomDialog,
    WonDialog,
    ErrorDialog
  }
})
export default class Room extends Vue {
  ws: WebSocket | null = null;
  onHome = goHome;
  error = false;
  curUser = "";
  roomId = this.$route.params.id;
  firstUser = "";
  secondUser = "";
  randomWords = (RandomWords(30) as string[]).join(" ");
  firstIncompleteString = this.randomWords;
  secondIncompleteString = this.randomWords;
  incompleteTextColor = "white";
  newJoinedUser = "";
  showAlert = false;
  copyAlert = false;
  firstCompleteString = "";
  secondCompleteString = "";
  counter: number | null = null;
  firstEnteredTextCount = 0;
  secondEnteredTextCount = 0;
  time = 0;
  firstWPM = 0;
  secondWPM = 0;
  winner = "";

  onJoin(userName: string) {
    const ws = new WebSocket(API_ENDPOINTS.socket(this.roomId, userName));

    this.listenToSocketMessages(ws, userName);
    this.listenToSocketErrors(ws);
  }

  listenToSocketMessages(ws: WebSocket, userName: string) {
    this.ws = ws;
    this.curUser = userName;

    this.firstUser = userName;

    ws.addEventListener("message", (e) => {
      type ThisType = { [x: string]: any };
      const event: EventResponse = JSON.parse(e.data);

      switch (event.event) {
        case Events.JOIN:
          if (event?.userName !== userName) {
            this.secondUser = event?.userName;
            ws.send(
              JSON.stringify({
                event: Events.RECEIVED_TEST,
                data: this.randomWords,
                userName
              } as EventResponse)
            );
          }

          this.newJoinedUser = event?.userName;
          this.showAlert = true;
          setTimeout(() => (this.showAlert = false), 2000);
          break;

        case Events.INITIATE_START:
          this.onStartRace();
          break;

        case Events.RECEIVED_TEST:
          if (event?.userName !== userName) {
            this.firstUser = event?.userName;
            this.secondUser = userName;
            this.randomWords = event?.data;
            this.firstIncompleteString = this.randomWords;
            this.secondIncompleteString = this.randomWords;
          }
          break;

        case Events.TYPING: {
          if (event.userName !== this.curUser) {
            const count = event?.data.length;
            const isFirst = event?.userName === this.firstUser;
            const incomplete = this.randomWords.slice(
              count,
              this.randomWords.length
            );
            const complete = this.randomWords.slice(0, count);

            (this as ThisType)[
              `${isFirst ? "first" : "second"}IncompleteString`
            ] = incomplete;
            (this as ThisType)[
              `${isFirst ? "first" : "second"}CompleteString`
            ] = complete;
          }
          break;
        }

        case Events.WON: {
          const timeLapsed = parseInt(event.data);
          this.winner = event.userName;
          this.firstWPM = Math.floor(
            (this.firstCompleteString.split(" ").length / timeLapsed) * 60
          );
          this.secondWPM = Math.floor(
            (this.secondCompleteString.split(" ").length / timeLapsed) * 60
          );

          break;
        }

        default:
          console.log("Error encountered");
      }
    });
  }

  listenToSocketErrors(ws: WebSocket) {
    ws.onerror = () => {
      this.error = true;
    };
  }

  initKeyPressListener() {
    const isFirst = this.curUser === this.firstUser;
    type ThisType = { [x: string]: any };
    this.trackTime();

    document.addEventListener("keypress", (event) => {
      if (event.keyCode == 32) event.preventDefault();

      if (
        event.key ===
        (this as ThisType)[`${isFirst ? "first" : "second"}IncompleteString`][0]
      ) {
        const data = this.randomWords.slice(
          0,
          ++(this as ThisType)[
            `${isFirst ? "first" : "second"}EnteredTextCount`
          ]
        );
        (this as ThisType)[
          `${isFirst ? "first" : "second"}CompleteString`
        ] = data;
        (this as ThisType)[
          `${isFirst ? "first" : "second"}IncompleteString`
        ] = this.randomWords.slice(data.length, this.randomWords.length);

        this.ws?.send(
          JSON.stringify({
            event: Events.TYPING,
            data,
            userName: this.curUser
          } as EventResponse)
        );
        if (data === this.randomWords) this.onWon();
      } else {
        this.incompleteTextColor = "red";
        setTimeout(() => (this.incompleteTextColor = "white"), 100);
      }
    });
  }

  onPressStart() {
    this.ws?.send(
      JSON.stringify({
        event: Events.INITIATE_START
      })
    );
  }

  onStartRace() {
    this.counter = 3;
    const interval = setInterval(() => {
      (this.counter as number)--;

      if (this.counter === 0) {
        window.clearInterval(interval);
        this.initKeyPressListener();
      }
    }, 1000);
  }

  onWon() {
    this.ws?.send(
      JSON.stringify({
        event: Events.WON,
        userName: this.curUser,
        data: String(this.time)
      } as EventResponse)
    );
  }

  trackTime() {
    const track = setInterval(() => {
      this.time++;

      if (
        (this as { [x: string]: any })[
          `${
            this.curUser === this.firstUser ? "first" : "second"
          }CompleteString`
        ] === this.randomWords
      ) {
        window.clearInterval(track);
      }
    }, 1000);
  }

  async onCopy() {
    copyToClipBoard(this.roomId, () => {
      this.copyAlert = true;
      setTimeout(() => (this.copyAlert = false), 2000);
    });
  }
}
